import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { searchMonitoring } from '../../modules/logistics/monitoring';

const mapStateToProps = state => {
	/** @namespace state.veederInventoryRecordIds **/
	/** @namespace state.maps.veederInventoryRecord **/

	let veederInventoryRecords = [];
	if (state.lists.veederInventoryRecordIds) {
		veederInventoryRecords = _.map(
			state.lists.veederInventoryRecordIds,
			id => state.maps.veederInventoryRecord[id]
		);
	}

	return {
		veederInventoryRecords,
		authUser : state.auth.authUser,
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
	searchMonitoring,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
